import api from './api';
const PREFIX = 'rolls-order-push:';
export const pushPreference = user => PREFIX + (user?.id || user?._id || '');
export function optedIn(user) { try { return localStorage.getItem(pushPreference(user)) === 'on'; } catch { return false; } }
function remember(user, value) { try { value ? localStorage.setItem(pushPreference(user), 'on') : localStorage.removeItem(pushPreference(user)); } catch {} }
export function supported() { return window.isSecureContext && 'serviceWorker' in navigator && 'PushManager' in window && typeof Notification !== 'undefined'; }
function bytes(key) { return Uint8Array.from(atob(key.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4-key.length%4)%4)), c => c.charCodeAt(0)); }
function sameKey(subscription, key) {
  const existing = subscription.options?.applicationServerKey;
  return existing && Array.from(new Uint8Array(existing)).join(',') === Array.from(bytes(key)).join(',');
}
async function registration() {
  const reg = await navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' });
  await navigator.serviceWorker.ready;
  return reg;
}
export async function enableOrderPush(user, requestPermission = true) {
  if (!supported()) throw new Error('Open Counter Culture in Chrome over HTTPS to enable order notifications.');
  if (requestPermission && Notification.permission !== 'granted') {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') throw new Error('Notifications are blocked. Allow them in Chrome site settings, then try again.');
  }
  if (Notification.permission !== 'granted') throw new Error('Notification permission is not granted.');
  const { data: config } = await api.get('/staff-order-push/config');
  if (!config.ready || !config.public_key) throw new Error('Order notifications are not ready on the server.');
  const reg = await registration();
  let sub = await reg.pushManager.getSubscription();
  if (sub && !sameKey(sub, config.public_key)) { await sub.unsubscribe(); sub = null; }
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: bytes(config.public_key) });
  const { data } = await api.post('/staff-order-push/subscribe', sub.toJSON());
  if (!data.ok || data.outlet_id !== config.outlet_id) throw new Error('Could not confirm notification registration. Try again.');
  remember(user, true);
  return data;
}
export async function testOrderPush() {
  const reg = await navigator.serviceWorker.getRegistration('/');
  const sub = await reg?.pushManager.getSubscription();
  if (!sub) throw new Error('Enable notifications on this device first.');
  const { data } = await api.post('/staff-order-push/test', { endpoint: sub.endpoint });
  if (!data.accepted) throw new Error('The push service did not accept this test.');
}
export async function disableOrderPush(user) {
  remember(user, false);
  if (!('serviceWorker' in navigator)) return;
  const reg = await navigator.serviceWorker.getRegistration('/');
  const sub = await reg?.pushManager.getSubscription();
  if (!sub) return;
  // Browser unsubscribe also invalidates delivery when the server is unreachable.
  try { await api.post('/staff-order-push/unsubscribe', { endpoint: sub.endpoint }, { timeout: 3000 }); }
  finally { await sub.unsubscribe(); }
}
